import { composeIO } from 'react-compose-io'
import { detalhesClassificacaoTabelaIO } from './DetalhesClassificacaoTabela.IO'
import { DetalhesClassificacaoTabelaView } from './DetalhesClassificacaoTabela.View'

export const DetalhesClassificacaoTabela = composeIO(DetalhesClassificacaoTabelaView, detalhesClassificacaoTabelaIO)
